var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tab-wrap"
  }, [_c('ul', {
    staticClass: "tab tab--block"
  }, [_c('li', {
    staticClass: "tab__li"
  }, [_c('button', {
    staticClass: "button tab__btn",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": function click($event) {
        return _vm.search('국내');
      }
    }
  }, [_vm._v("Domestic")])]), _c('li', {
    staticClass: "tab__li"
  }, [_c('button', {
    staticClass: "button tab__btn",
    class: {
      active: !_vm.isActive
    },
    on: {
      "click": function click($event) {
        return _vm.search('해외');
      }
    }
  }, [_vm._v("Oversea")])])])]), _c('table', {
    staticClass: "board-list d-none d-lg-table"
  }, [_c('thead', {
    staticClass: "d-none d-lg-table-header"
  }, [_c('tr', [_c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "30%"
    }
  }), _c('th', {
    staticClass: "board-list__tit",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Company")]), _c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Details")])])])]), _c('div', {
    staticClass: "partner-group"
  }, _vm._l(_vm.partners, function (partner) {
    return _c('div', {
      key: partner._id,
      staticClass: "d-flex flex-column flex-lg-row align-start align-lg-stretch partner-wrap"
    }, [_c('div', [_c('div', {
      staticClass: "partner-thum-wrap",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('img', {
      staticClass: "partner-thum",
      attrs: {
        "src": partner.thumb
      },
      on: {
        "click": function click($event) {
          return _vm.open(partner.company.URL);
        }
      }
    })])]), _c('div', {
      staticClass: "parnter-info"
    }, [_vm._v(_vm._s(partner.company.name))]), _c('div', {
      staticClass: "parnter-info ellip"
    }, [_vm._v(_vm._s(partner.company.about))])]);
  }), 0), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }